<template>
  <div class="flex-spacer" />
</template>

<style lang="scss">
  .flex-spacer {
    flex: 1;
  }
</style>